import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import DropDown, { OptionType } from "../../../../Filters/DropDown";
import { sunsetDetailButtonType } from "../SunsetDetailButtons";
import { ISunsetData } from "./SunsetDetailInfo";
import {
  sunsetDetailDataState,
  VerticalTableLabel,
  VerticalTableRow,
  VerticalTableValue,
} from "./SunsetSubs";
import sunsetUserEvent from "../../../../../datafiles/ssetuserevent_set.json";

// 일몰 템플릿 리스트
const sunsetTemplate = [] as OptionType[];

sunsetUserEvent?.forEach((a) =>
  sunsetTemplate.push({
    value: `${a?.SSETTEMPLATE_ID}`,
    label: a?.SSETTEMPLATE_NM,
  })
);

export const getAlTempNumber = (label: string) => {
  const data = sunsetTemplate?.find((a) => a.label === label);

  return data?.value ?? "";
};

export default function SunsetReason() {
  const location = useLocation() as unknown as ISunsetData;
  const buttonType = useRecoilValue(sunsetDetailButtonType);

  const [sunsetDetailData, setSunsetDetailData] = useRecoilState(
    sunsetDetailDataState
  );
  const [sunsetReasonOption, setSunsetReasonOption] = useState<OptionType[]>([
    { value: "", label: "" },
  ]);
  const [reason, setReason] = useState({
    value: location?.state
      ? getAlTempNumber(
          location?.state?.sunsetData?.customvar?.alertcat ?? ""
        ) ?? ""
      : "",
    label: location?.state
      ? location?.state?.sunsetData?.customvar?.alertcat ?? "선택"
      : "선택",
  });

  useEffect(() => {
    setSunsetReasonOption(sunsetTemplate);
  }, []);

  useEffect(() => {
    if (reason?.label !== "") {
      setSunsetDetailData({
        ...sunsetDetailData,
        sunsetReason: reason?.label !== "" ? reason?.label : "",
      });
    }
  }, [reason]);

  return (
    <VerticalTableRow>
      <VerticalTableLabel>일몰 템플릿</VerticalTableLabel>

      {buttonType === "view" ? (
        <VerticalTableValue>
          {reason?.label !== "" ? reason?.label : "-"}
        </VerticalTableValue>
      ) : (
        <DropDown
          optionList={sunsetReasonOption}
          dropdownValue={reason}
          setDropDownValue={setReason}
        />
      )}
    </VerticalTableRow>
  );
}
